import get from 'lodash/get';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './IntegrationVerification.scss';

const Status = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

class IntegrationVerification extends PureComponent {
  onClick = () => {
    this.props.onClick(this.props.dealer);
  };

  render() {
    const verification = this.props.verifications[this.props.type].toObject();
    const status = get(verification, 'data.status');
    const message = get(verification, 'data.message');

    let alert = null;
    if (verification.error || status === Status.FAILURE) {
      const errorMsg =
        typeof verification.error === 'string'
          ? verification.error
          : verification.error?.error;
      alert = (
        <Alert bsStyle="danger">
          {errorMsg || message || 'Invalid credentials.'}
        </Alert>
      );
    } else if (status === Status.SUCCESS) {
      alert = <Alert bsStyle="success">Credentials are valid.</Alert>;
    }

    return (
      <div className="integration-verification">
        <Button disabled={verification.fetching} onClick={this.onClick}>
          {verification.fetching ? 'Checking...' : this.props.label}
        </Button>
        {!verification.fetching && alert}
      </div>
    );
  }
}

IntegrationVerification.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  dealer: PropTypes.object,
  verifications: PropTypes.object,
};

const mapStateToProps = (state) => ({
  verifications: state.verifications,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntegrationVerification);
